const TangoRomanticaLead = {
    name: "Tango Romantica",
    bpm: 112,
    signature: "4/4",
    introMeasures: 8,
    pattern: [

    ]
};

export default TangoRomanticaLead;